export class Auctioneer {
	auctioneerName: string;
	auctionType: string;
	productType: string;
	adjudication: string;
	authorizedDealers: string;
	enabled: boolean;
}

export class AuctioneerDTO {
	dealerBusinessName?: string;
	email?: string;
	idDealer?: number;
	idMarket?: string;
	idUser?: number;
	name?: string;
	surname?: string;
	username?: string;
	flgEnabled: boolean;
}

export class EnableAuctioneerDTO {
	enabled?: boolean;
	idDealer?: number;
}

export class MultiAuctioneerTemplateEnableDTO {
	idDealer?: number;
	idTemplate?: number;
}

export class FeedbackDTO {

	idAuctioneer: number;
	rating: number;
}